document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('looksmaxxing-form');
  if (!form) return;

  const AYUBA_PRODUCTS = {
    creatine: {
      name: 'Creatine Monohydrate',
      handle: 'creatine-monohydrate-1000g',
      benefit: 'Strength, muscle mass, cognitive performance'
    },
    whey: {
      name: 'Premium Whey Protein',
      handle: 'premium-whey-protein-vanille-1kg',
      benefit: 'Muscle building, recovery'
    },
    omega3: {
      name: 'Super Omega 3',
      handle: 'super-omega-3-120-softgels',
      benefit: 'Heart, brain, inflammation'
    },
    collagen: {
      name: 'Pure Sea Collagen',
      handle: 'pure-sea-collagen-120-kapseln',
      benefit: 'Skin, hair, nails'
    },
    magnesium: {
      name: 'MAGNESIUM 4MAX',
      handle: 'magnesium-4max-60-kapseln',
      benefit: 'Muscles, sleep'
    },
    melatonin: {
      name: 'Melatonin',
      handle: 'melatonin-75-kapseln',
      benefit: 'Sleep onset'
    },
    vitaminD: {
      name: 'Vitamin D3 + K2',
      handle: 'vitamin-d3-k2-1-700-tropfen-1-000-i-e-50ml',
      benefit: 'Immune system'
    },
    hydration: {
      name: 'Daily Hydration',
      handle: 'daily-hydration-basis-elektrolyte-fresh-mango-300g',
      benefit: 'Electrolytes'
    },
    preWorkout: {
      name: 'Lite Energy Pre-Workout',
      handle: 'lite-energy-pre-workout-booster-fresh-orange-520g',
      benefit: 'Focus, energy'
    },
    multiShots: {
      name: 'All-In-One Multi Shots',
      handle: 'all-in-one-multi-shots-vitamins-minerals-amino-acids-herb-blend-50-vegane-shots-bio-orange-500ml',
      benefit: 'Vitamins'
    }
  };

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    
    // Show loading
    const resultsDiv = document.getElementById('results');
    resultsDiv.innerHTML = '<div style="text-align:center;padding:60px 20px;"><div style="border:4px solid #ff4d00;border-top:4px solid transparent;border-radius:50%;width:60px;height:60px;margin:0 auto 20px;animation:spin 1s linear infinite;"></div><p style="font-size:18px;color:#e5e5e5;">Generating your protocol...</p></div><style>@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}</style>';
    resultsDiv.classList.add('active');
    resultsDiv.scrollIntoView({behavior: 'smooth', block: 'start'});
    
    // Simulate processing time
    setTimeout(function() {
      const data = {
        age: parseInt(document.getElementById('age').value),
        sex: document.getElementById('sex').value,
        sleep: parseInt(document.getElementById('sleep').value),
        stress: parseInt(document.getElementById('stress').value),
        training: document.getElementById('training').value,
        bodyfat: document.getElementById('bodyfat').value,
        budget: document.getElementById('budget').value,
        priority: document.getElementById('priority').value,
        skinIssues: Array.from(document.querySelectorAll('input[id^="skin-"]:checked')).map(cb => cb.value),
        hairIssues: Array.from(document.querySelectorAll('input[id^="hair-"]:checked')).map(cb => cb.value)
      };
      
      let html = '<h2 style="margin-top:0;">Your Personalized PHENOMAX™ Protocol</h2>';
      
      // Phase 1
      html += '<div class="protocol-section"><h3>Phase 1: Immediate (0-7 Days)</h3>';
      
      if (data.sleep <= 2) {
        html += '<div class="protocol-item"><strong>🔴 PRIORITY: Sleep Emergency Protocol</strong>';
        html += '<p>Your sleep quality is critically low.</p><ul>';
        html += '<li>Fixed bedtime: 11 PM, wake time: 7 AM (7 days consistent)</li>';
        html += '<li>No caffeine after 2 PM</li>';
        html += '<li>100% room darkening, temperature 16-18°C</li>';
        html += '<li>30 min morning sunlight immediately after waking</li>';
        html += '<li>Minimize screens 2h before bed</li></ul></div>';
      } else if (data.sleep === 3) {
        html += '<div class="protocol-item"><strong>Sleep Optimization</strong><ul>';
        html += '<li>Sleep consistency: Same times on weekends too</li>';
        html += '<li>Caffeine cutoff: 10h before bedtime</li>';
        html += '<li>Evening routine: 30 min wind-down without screens</li></ul></div>';
      }
      
      if (data.stress >= 4) {
        html += '<div class="protocol-item"><strong>⚠ Stress Reduction (Acute)</strong>';
        html += '<p>Chronic stress elevates cortisol → facial puffiness, acne trigger, fat storage.</p><ul>';
        html += '<li>Daily 10-min meditation (Headspace, Calm)</li>';
        html += '<li>20 min outdoor walk daily</li>';
        html += '<li>Prioritize social interaction</li>';
        html += '<li>Reduce screen time</li></ul></div>';
      }
      
      html += '<div class="protocol-item"><strong>Water & Electrolyte Management</strong><ul>';
      html += '<li>Baseline: 30-35ml/kg body weight daily</li>';
      html += '<li>Morning: 500ml with pinch of salt</li>';
      html += '<li>Urine color: Pale yellow as target</li>';
      html += '<li>Reduce alcohol (dehydrates, increases facial puffiness)</li></ul></div>';
      
      html += '<div class="protocol-item"><strong>Posture Awareness</strong><ul>';
      html += '<li>Hourly: Shoulders back, chest out, chin tucked</li>';
      html += '<li>Screen at eye level</li>';
      html += '<li>When walking: Upright posture signals dominance</li></ul></div>';
      html += '</div>';
      
      // Phase 2
      html += '<div class="protocol-section"><h3>Phase 2: Short-term (2-6 Weeks)</h3>';
      
      if (data.training === 'none') {
        html += '<div class="protocol-item"><strong>Resistance Training Start (PRIORITY)</strong>';
        html += '<p>Highest ROI intervention for body aesthetics.</p><ul>';
        html += '<li>Frequency: 3×/week (Mon/Wed/Fri)</li>';
        html += '<li>Full-body routine: Squat, Bench Press, Rows, Overhead Press, Deadlift</li>';
        html += '<li>3 sets × 8-12 reps</li>';
        html += '<li>Progressive overload: +2.5kg or +1 rep weekly</li></ul></div>';
      } else if (data.training === 'beginner') {
        html += '<div class="protocol-item"><strong>Training Intensification</strong><ul>';
        html += '<li>Increase volume: 4×/week training</li>';
        html += '<li>Implement Upper/Lower split</li>';
        html += '<li>Isolation for weak points</li></ul></div>';
      } else if (data.training === 'intermediate' || data.training === 'advanced') {
        html += '<div class="protocol-item"><strong>Training Optimization</strong><ul>';
        html += '<li>Volume phases: 10-20 sets/muscle group/week</li>';
        html += '<li>Deload every 4th week</li>';
        html += '<li>Posture-specific: Face pulls, neck curls</li></ul></div>';
      }
      
      if (data.bodyfat === 'high' || data.bodyfat === 'average') {
        html += '<div class="protocol-item"><strong>Fat Loss Start</strong>';
        html += '<p>Improve facial definition through moderate fat reduction.</p><ul>';
        html += '<li>Caloric deficit: 300-500 kcal/day (0.5-1% BW/week)</li>';
        html += '<li>Keep protein high: 2.0g/kg body weight</li>';
        html += '<li>Maintain resistance training (muscle retention)</li>';
        html += '<li>Tracking: Weekly photos + waist circumference</li></ul></div>';
      }
      
      html += '<div class="protocol-item"><strong>UV Protection Implementation</strong>';
      html += '<p>Starts photoaging prevention.</p><ul>';
      html += '<li>Daily broad-spectrum sunscreen SPF 30+ (indoor too, winter)</li>';
      html += '<li>Apply: 2 mg/cm² (generous amount)</li>';
      html += '<li>Reapply: Every 2h with outdoor exposure</li></ul></div>';
      
      if (data.skinIssues.length > 0) {
        html += '<div class="protocol-item"><strong>Skincare Routine Start</strong><ul>';
        if (data.skinIssues.includes('acne')) {
          html += '<li><strong>Acne:</strong> Benzoyl peroxide 2.5% (AM) + OTC retinol 0.5% (PM 2×/week start)</li>';
        }
        if (data.skinIssues.includes('aging')) {
          html += '<li><strong>Anti-aging:</strong> Vitamin C serum (AM) + Retinol (PM)</li>';
        }
        if (data.skinIssues.includes('pigmentation')) {
          html += '<li><strong>Pigmentation:</strong> Niacinamide 5% (AM+PM)</li>';
        }
        if (data.skinIssues.includes('texture')) {
          html += '<li><strong>Texture:</strong> AHA 5-10% 2×/week</li>';
        }
        if (data.skinIssues.includes('redness')) {
          html += '<li><strong>Redness:</strong> Azelaic acid 10%</li>';
        }
        if (data.skinIssues.includes('dryness')) {
          html += '<li><strong>Dryness:</strong> Ceramide moisturizer 2×/day</li>';
        }
        html += '<li>Gentle cleanser 2×/day</li>';
        html += '<li>Moisturizer after all actives</li>';
        html += '<li>Sunscreen ALWAYS in AM (final step)</li></ul></div>';
      }
      html += '</div>';
      
      // Phase 3
      html += '<div class="protocol-section"><h3>Phase 3: Medium-term (2-6 Months)</h3>';
      
      if (data.skinIssues.includes('aging') || data.skinIssues.includes('acne')) {
        html += '<div class="protocol-item"><strong>Retinoid Escalation (Consider Tretinoin)</strong>';
        html += '<p>After 8-12 weeks OTC retinol, consider physician consultation for tretinoin 0.025%.</p><ul>';
        html += '<li>Strongest anti-aging + acne evidence</li>';
        html += '<li>Requires prescription</li>';
        html += '<li>Start slow: 2×/week, gradually increase</li>';
        html += '<li>Mandatory: Daily sunscreen</li></ul></div>';
      }
      
      if (data.hairIssues.includes('thinning') || data.hairIssues.includes('shedding')) {
        html += '<div class="protocol-item"><strong>💊 Hair Loss Treatment (Evidence-Based)</strong>';
        html += '<p style="margin-bottom:12px;">Two main options with high scientific evidence:</p>';
        
        html += '<p style="margin:12px 0 8px 0;"><strong>Option 1: Minoxidil 5% (OTC - Start immediately possible)</strong></p><ul>';
        html += '<li><strong>Evidence:</strong> High (FDA-approved, stops progression ~80%, regrowth ~40-60%)</li>';
        html += '<li><strong>Application:</strong> 2×/day topical (foam better tolerated than solution)</li>';
        html += '<li><strong>Timeframe:</strong> 4-6 months for visible results, ongoing use required</li>';
        html += '<li><strong>Side effects:</strong> Scalp irritation, initial shedding (first 2-4 weeks), rarely systemic</li>';
        html += '<li><strong>Availability:</strong> Pharmacy without prescription</li></ul>';
        
        html += '<p style="margin:16px 0 8px 0;"><strong>Option 2: Finasteride 1mg (Prescription)</strong></p><ul>';
        html += '<li><strong>Evidence:</strong> High (stops progression ~85-90%, regrowth ~60-65%)</li>';
        html += '<li><strong>Mechanism:</strong> Blocks DHT production (main cause of hair loss)</li>';
        html += '<li><strong>Timeframe:</strong> 3-6 months for stabilization, 12+ months for maximum regrowth</li>';
        html += '<li><strong>Side effects:</strong> Sexual dysfunction (2-4% in studies, rarely persistent), mood changes (EMA safety warning)</li>';
        html += '<li><strong>Requirements:</strong> Physician consultation, mental health screening, informed consent</li>';
        html += '<li><strong>Not suitable with:</strong> Depression, anxiety disorder (without clearance)</li></ul>';
        
        html += '<p style="margin:16px 0 8px 0;"><strong>Recommended Strategy:</strong></p><ul>';
        html += '<li><strong>Start:</strong> Minoxidil 5% immediately (test 3-6 months)</li>';
        html += '<li><strong>Escalation:</strong> After 3-6 months minoxidil → physician appointment for finasteride if insufficient</li>';
        html += '<li><strong>Combination:</strong> Minoxidil + finasteride = strongest evidence (if tolerated)</li>';
        html += '<li><strong>Micronutrients:</strong> Iron + vitamin D blood test (fix deficiencies)</li></ul>';
        
        html += '<p style="margin:16px 0 0 0;font-size:14px;color:#a0a0a0;"><strong>Important:</strong> Both options require long-term application. Hair loss returns upon discontinuation. Realistic expectations: Stabilization more likely than dramatic regrowth.</p></div>';
      }
      
      html += '<div class="protocol-item"><strong>Nutrition Refinement</strong><ul>';
      html += '<li>Macro tracking: Protein 2.0g/kg, fat 0.8g/kg, rest carbs</li>';
      html += '<li>Micronutrient density: 5+ servings vegetables/fruits daily</li>';
      html += '<li>Lower glycemic load if acne present</li></ul></div>';
      html += '</div>';
      
      // Ayuba Stack
      const selected = [];
      if (data.training !== 'none') {
        selected.push(AYUBA_PRODUCTS.creatine);
        selected.push(AYUBA_PRODUCTS.whey);
      }
      if (data.sleep <= 3 || data.stress >= 4) {
        selected.push(AYUBA_PRODUCTS.magnesium);
        if (data.sleep <= 2) selected.push(AYUBA_PRODUCTS.melatonin);
      }
      if (data.priority === 'skin' || data.skinIssues.length > 0) {
        selected.push(AYUBA_PRODUCTS.collagen);
        selected.push(AYUBA_PRODUCTS.omega3);
      }
      if (data.priority === 'hair' || data.hairIssues.length > 0) {
        selected.push(AYUBA_PRODUCTS.collagen);
      }
      if (data.priority === 'physique' && data.training !== 'none') {
        selected.push(AYUBA_PRODUCTS.preWorkout);
        selected.push(AYUBA_PRODUCTS.hydration);
      }
      if (data.priority === 'overall') {
        selected.push(AYUBA_PRODUCTS.multiShots);
        selected.push(AYUBA_PRODUCTS.vitaminD);
      }
      
      const unique = [...new Set(selected)];
      const limited = data.budget === 'low' ? unique.slice(0, 2) : data.budget === 'medium' ? unique.slice(0, 4) : unique.slice(0, 6);
      
      html += '<div class="protocol-section"><h3>Your Ayuba Nutrition Performance Stack</h3>';
      html += '<p style="margin-bottom:15px;">Evidence-based, tailored to your profile:</p>';
      html += '<div class="product-stack">';
      limited.forEach(product => {
        html += '<div class="product-card">';
        html += '<div class="product-name">' + product.name + '</div>';
        html += '<div class="product-benefit">' + product.benefit + '</div>';
        html += '<div class="product-actions">';
        html += '<a href="/products/' + product.handle + '" class="btn btn-primary" style="padding:8px 12px;font-size:13px;width:100%;">View Product</a>';
        html += '</div></div>';
      });
      html += '</div></div>';
      
      // Tracking
      html += '<div class="protocol-section"><h3>Metrics & Tracking</h3>';
      html += '<div class="protocol-item"><strong>Track weekly:</strong><ul>';
      html += '<li>Progress photos (same lighting, angle, time of day)</li>';
      html += '<li>Waist circumference (fasted, same time)</li>';
      html += '<li>Weight (7-day trend)</li>';
      html += '<li>Strength metrics (bench/squat/deadlift progression)</li></ul></div>';
      html += '<div class="protocol-item"><strong>Track daily:</strong><ul>';
      html += '<li>Sleep quality (1-10 score or app)</li>';
      html += '<li>Steps/NEAT</li>';
      html += '<li>Energy level (subjective 1-10)</li></ul></div></div>';
      
      // Warnings
      html += '<div class="warning-box"><h4>⚠ Important Safety Information</h4><ul>';
      html += '<li><strong>Not medical advice:</strong> This protocol does not replace professional medical advice. Consult physician before starting.</li>';
      html += '<li><strong>RED-S warning:</strong> Stop immediately if: amenorrhea >3 months, persistent fatigue, mood disturbance.</li>';
      html += '<li><strong>Prescription meds:</strong> Tretinoin, finasteride, isotretinoin require medical supervision.</li>';
      html += '<li><strong>Finasteride mental health:</strong> Do not use with depression/anxiety without psychiatric clearance.</li>';
      html += '<li><strong>Excluded:</strong> UV tanning, bone smashing, extreme dehydration, unapproved peptides.</li>';
      html += '<li><strong>Mental health:</strong> If body dysmorphic disorder symptoms → contact mental health professional.</li></ul></div>';
      
      resultsDiv.innerHTML = html;
    }, 2000);
  });
});
